import React from 'react';
import { Tooltip } from 'react-tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
import { Creators as Actions } from "store/ducks/quotesDashboard";
//components
import IndicatorRefreshButton from '../IndicatorRefreshButton';
import { Column, Row } from 'components/Layout/Grid';
import { Visibility } from 'components/Visibility';
import Loading from 'components/Loading';
import Text from 'components/Text';
//models
import { IQuoteIndicator } from '../models/quoteIndicator';
//assets
import pendingMoneyError from "img/pending-money-error-icon.svg";
//utils
import { handleIndicatorFilter } from './utils';
//styles
import { colors } from '../../styles/colors';
import '../../styles.scss';

const QuoteLayoutIndicator: React.FC<IQuoteIndicator> = ({
  data,
  onReload,
  getPreOrder,
  setOrderStatus,
  getBionexoQuote,
  tooltipContent,
  tooltipPlace,
  setStatusViveo,
  setStatusBionexo,
  setSelectedRadio,
  setQuoteCategory,
  setOrderRadioSelected,
}) => {
  const { error, loading, title, value } = data;

  const pendingMoneyRule = data.title === "PENDENTE MONEY";
  const isSentExpired = data.title === "ENVIADAS/EXPIRADAS";

  const reactTooltipId = `ReactTooltip${Math.random().toString().split('.')[1]}`;

  const selectedFilterCard = useSelector((stateFilter: RootState) => stateFilter.quotesDashboard?.selectedFilterCard);

  const isSelected = selectedFilterCard === data.title;

  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(Actions.setSelectedFilterCard(data.title));

    dispatch(Actions.setSentExpiredFilter(isSentExpired));

    handleIndicatorFilter(
      dispatch,
      setStatusBionexo,
      setStatusViveo,
      setOrderStatus!,
      setQuoteCategory,
      getBionexoQuote!,
      getPreOrder!,
      setSelectedRadio!,
      setOrderRadioSelected!,
      data.title
    );
  };

  const getTextColor = (isSelected: boolean, pendingMoneyRule: boolean) => {
    if (isSelected) return "#287C87";
    if (pendingMoneyRule) return "#E02828";
    return colors.blueViveo;
  };
  
  const textColor = getTextColor(isSelected, pendingMoneyRule);

  return (
    <>
      <div
        data-tooltip-content={tooltipContent || 'Clique para filtrar'}
        data-tooltip-id={reactTooltipId}
        data-tooltip-place={tooltipPlace || 'top'}
        className={`mt-6 mb-3 custom-indicators-filter flex-row ${isSelected ? 'selected' : ''}`}
      >
        <Column
          className={`bg-white mr-md-0 indicator ${isSelected ? 'selected' : ''}`}
          onClick={handleClick}
        >
          <Column className="title-subtitle">
            <Text size={14} className={`${isSelected ? 'custom-title' : 'subtitle'} color-blueDark`}>
              {title}
            </Text>
          </Column>

          <Visibility visible={!error && !loading}>
            <Visibility visible={!pendingMoneyRule}>
              <Text size={32} className="pp-text-uppercase font-bold" color={textColor}>
                {value}
              </Text>
            </Visibility>

            <Visibility visible={pendingMoneyRule}>
              <div className='container-pending-money'>
                <img className="pending-money-error" width={24} alt='' src={pendingMoneyError} />
                <Text size={32} className="pp-text-uppercase font-bold" color={textColor}>
                  {value}
                </Text>
              </div>
            </Visibility>
          </Visibility>

          <Visibility visible={error}>
            <Row className="indicatorLoading">
              <IndicatorRefreshButton onReload={onReload} refreshSize={"20px"} />
            </Row>
          </Visibility>
          
          <Visibility visible={loading}>
            <Row className="indicatorLoading">
              <Loading onlySpinner />
            </Row>
          </Visibility>
        </Column>
      </div>

      <Visibility visible={!!data}>
        <Tooltip className="z-999-important" id={reactTooltipId} variant={'light'} />
      </Visibility>
    </>
  );
};

export default QuoteLayoutIndicator;
